// Import auth utilities
import { checkResponseStatus } from '../utils/authUtils';

// Service for utility-related API calls

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function getAuthToken() {
  return localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
}

export async function fetchPaidUtility(page = 1, limit = 16, filters = {}) {
  if (!API_BASE_URL) {
    throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
  }

  const accessToken = getAuthToken();
  const headers = {
    'Content-Type': 'application/json',
  };
  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
    headers['Cookie'] = `jwt=${accessToken}`;
  }

  // Build query parameters
  const queryParams = new URLSearchParams();
  queryParams.append('page', page);
  queryParams.append('limit', limit);

  if (filters.date) {
    queryParams.append('date', filters.date);
  }
  if (filters.projectId) {
    queryParams.append('project', filters.projectId);
  }
  if (filters.customerId) {
    queryParams.append('customer', filters.customerId);
  }

  const url = `${API_BASE_URL}api/v1/dashboard/utility/previous?${queryParams.toString()}`;
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  // Check for 401 status
  checkResponseStatus(response);

  if (!response.ok) {
    throw new Error(`Failed to fetch paid utility: ${response.status}`);
  }

  const data = await response.json();
  return data;
}

export async function fetchUnpaidUtility(page = 1, limit = 16, filters = {}) {
  if (!API_BASE_URL) {
    throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
  }

  const accessToken = getAuthToken();
  const headers = {
    'Content-Type': 'application/json',
  };
  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
    headers['Cookie'] = `jwt=${accessToken}`;
  }

  // Build query parameters
  const queryParams = new URLSearchParams();
  queryParams.append('page', page);
  queryParams.append('limit', limit);

  if (filters.date) {
    queryParams.append('date', filters.date);
  }
  if (filters.projectId) {
    queryParams.append('project', filters.projectId);
  }
  if (filters.customerId) {
    queryParams.append('customer', filters.customerId);
  }

  const url = `${API_BASE_URL}api/v1/dashboard/utility/remaining?${queryParams.toString()}`;
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  // Check for 401 status
  checkResponseStatus(response);

  if (!response.ok) {
    throw new Error(`Failed to fetch unpaid utility: ${response.status}`);
  }

  const data = await response.json();
  return data;
}

export async function closeUtility(utilityId) {
  if (!API_BASE_URL) {
    throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
  }

  const accessToken = getAuthToken();
  const headers = {
    'Content-Type': 'application/json',
  };
  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
    headers['Cookie'] = `jwt=${accessToken}`;
  }

  const url = `${API_BASE_URL}api/v1/dashboard/utility/close?utility_id=${utilityId}`;
  const response = await fetch(url, {
    method: 'PATCH',
    headers,
  });

  // Check for 401 status
  checkResponseStatus(response);

  if (!response.ok) {
    throw new Error(`Failed to close utility: ${response.status}`);
  }

  const data = await response.json();
  return data;
}

export async function openUtility(utilityId) {
  if (!API_BASE_URL) {
    throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
  }

  const accessToken = getAuthToken();
  const headers = {
    'Content-Type': 'application/json',
  };
  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
    headers['Cookie'] = `jwt=${accessToken}`;
  }

  const url = `${API_BASE_URL}api/v1/dashboard/utility/open?utility_id=${utilityId}`;
  const response = await fetch(url, {
    method: 'PATCH',
    headers,
  });

  // Check for 401 status
  checkResponseStatus(response);

  if (!response.ok) {
    throw new Error(`Failed to open utility: ${response.status}`);
  }

  const data = await response.json();
  return data;
}

export async function deleteUtility(utilityId) {
  if (!API_BASE_URL) {
    throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
  }

  const accessToken = getAuthToken();
  const headers = {
    'Content-Type': 'application/json',
  };
  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
    headers['Cookie'] = `jwt=${accessToken}`;
  }

  const url = `${API_BASE_URL}api/v1/dashboard/utility/delete/${utilityId}`;
  const response = await fetch(url, {
    method: 'DELETE',
    headers,
  });

  // Check for 401 status
  checkResponseStatus(response);

  if (!response.ok) {
    throw new Error(`Failed to delete utility: ${response.status}`);
  }

  const data = await response.json();
  return data;
}

export async function exportUtility(status) {
  if (!API_BASE_URL) {
    throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
  }

  const accessToken = getAuthToken();
  const headers = {
    'Content-Type': 'application/json',
  };
  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
    headers['Cookie'] = `jwt=${accessToken}`;
  }

  const url = `${API_BASE_URL}api/v1/dashboard/utility/export`;
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  // Check for 401 status
  checkResponseStatus(response);

  if (!response.ok) {
    throw new Error(`Failed to export utility: ${response.status}`);
  }

  // Handle file download
  const blob = await response.blob();
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = `utility_${status}_${new Date().toISOString().split('T')[0]}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(downloadUrl);
  
  return { success: true };
}